import React, { Fragment } from 'react';
import type { ModelPortfolios } from '@raisin/investments-data/api/contentStack/types';
import { FAQMarkupScript } from '../components/FAQMarkupScript';
import { ContentProps, USProductOffer } from '../types';
import { components, getComponent } from './componentsList';
import { getFAQMarkupQueries } from './getFAQMarkupQueries';

const getPageContent = (
  content: ContentProps,
  formatMessage: Function,
  modelPortfolios: ModelPortfolios | undefined,
  contentEntries = {},
  usProductOffers: Array<USProductOffer> = [],
) => {
  if (!content || !content?.componentData) {
    // eslint-disable-next-line no-console
    console.warn('No content is found.');
    return null;
  }
  return (
    <Fragment key={content.componentData.uid}>
      <FAQMarkupScript queries={getFAQMarkupQueries(content)} />

      {getComponent(content.componentName as keyof typeof components)?.(
        content.componentData,
        formatMessage,
        modelPortfolios as ModelPortfolios,
        contentEntries,
        usProductOffers,
      )}
    </Fragment>
  );
};

export default getPageContent;
